import { request } from '@/utils/request';
import * as url from '@/src/constant';

const ROUTE_SALARY = '/pages/salary/index';

/**
 * 获取佣金合计信息
 * @param query
 * @returns {Promise<TResult>}
 */
export function fetchSalaryNum(query) {
  return request({
    url: url.QUERY_SALARYINFO_URL,
    query,
    method: "POST",
    returnUrl: ROUTE_SALARY
  });
}

/**
 * 获取佣金记录信息
 * @param query
 * @returns {Promise<TResult>}
 */
export function fetchSalaryList(query) {
  return request({
    url: url.QUERY_SALARY_ORDER_PAGINATION_URL,
    query,
    method: "POST",
    returnUrl: ROUTE_SALARY
  });
}

// 查询任务详情
export function fetchTaskDetailInfo(query) {
  return request({
    url: url.QUERY_SALARY_ORDER_URL,
    query,
    method: "POST",
    returnUrl: ROUTE_SALARY
  });
}
